export const LEGACY_REVIEW_PAGE_ID = 'Legacy Template';
